export enum BankAccountType {
  BusinessChecking,
  BusinessSavings,
  PersonalChecking,
  PersonalSavings,
}
